import { IOnInit } from "angular";

import { IFilterDate, IFormController } from "angular";
import { IFieldArray, IFormOptionsAPI } from "AngularFormly";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../records/server/serverUtility";
import { IReportGroup } from "../../../reporting/interfaces/IReportGroup";
import fieldHelpers from "../../../ui-formly/fieldHelpers";
import { orderBy } from "lodash";
import { Machine } from "../../../machines/shared/models/machine";
import { MachineConfiguration } from "../../../machines/shared/models/machineConfiguration";
import { ProgressiveDefinition } from "../../../machines/gateway/models/progressiveDefinition";

type FormInfo = {
  editing: boolean;
  form: IFormController;
  formlyOptions: IFormOptionsAPI;
};

export class ProgressiveMachineDetailConfigurationComponentController
  implements IOnInit
{
  static $inject = ["dateFilter", ServerUtilityName, "currencyFilter"];

  startDate: Date | undefined;
  endDate: Date | undefined;
  startDateCalendarOpened = false;
  endDateCalendarOpened = false;
  readonly machineNotesFields: IFieldArray = [
    fieldHelpers.textAreaField({
      key: "Notes",
      name: "Notes",
      label: "Notes",
      rows: 5,
    }),
  ];

  readonly machine!: Machine<MachineConfiguration>;
  readonly date!: Date;
  readonly progressiveDefinitionMachines!: any[];
  readonly progressiveReportGroup!: IReportGroup;
  readonly progressiveDefinitions!: ProgressiveDefinition[];

  constructor(
    private readonly dateFilter: IFilterDate,
    private readonly serverUtility: ServerUtility,
    private readonly currencyFilter: (...args: any[]) => string
  ) {}

  $onInit(): void {}

  getProgressiveDefinitionMachine(progressiveDefinition: any) {
    return this.progressiveDefinitionMachines.find(
      (m) => m.ProgressiveDefinitionId === progressiveDefinition.Id
    );
  }

  getConfigurations() {
    return orderBy(
      this.machine.Configs?.filter(
        (mc: any) =>
          (this.startDate === undefined || mc.Date >= this.startDate) &&
          (this.endDate === undefined || mc.Date <= this.endDate)
      ),
      ["Order"],
      ["desc"]
    );
  }

  clearFilters() {
    this.startDate = this.endDate = undefined;
  }

  setFormOpen(formInfo: FormInfo, open: boolean) {
    formInfo.editing = open;
  }

  getAccordionHeading(
    configuration: any,
    progressiveDefinitionMachines: any[]
  ) {
    const configurationDate: Date = configuration.Date;
    const systemDate: Date = this.date;
    const currentConfiguration: boolean = configuration.CurrentConfiguration;

    const futureChange = configurationDate > systemDate;
    const changeTypeDetail = configuration.ConversionTypeName
      ? `(${configuration.ConversionTypeName})`
      : "";

    const progressiveCount = progressiveDefinitionMachines?.length ?? 0;

    return `${configuration.ChangeType}${changeTypeDetail} - ${this.dateFilter(
      configurationDate
    )}${currentConfiguration && !futureChange ? " - Current" : ""}${
      futureChange ? " - Pending" : ""
    } - ${progressiveCount} progressives`;
  }

  submitForm(formInfo: FormInfo, progressiveDefinitionMachine: any) {
    this.serverUtility
      .patch({
        url: "/api/machines/progressives/ProgressiveDefinitionMachine",
        patchObject: {
          Id: progressiveDefinitionMachine.Id,
          Notes: progressiveDefinitionMachine.Notes,
        },
      })
      .then(() => {
        this.setFormOpen(formInfo, false);
      });
  }

  cancelForm(formInfo: FormInfo) {
    formInfo.formlyOptions.resetModel?.call(undefined);
    this.setFormOpen(formInfo, false);
  }

  getCeilingDisplay(ceiling?: number) {
    return ceiling ? this.currencyFilter(ceiling, "$", 2) : "N/A";
  }

  getProgressiveDefinition(progressiveDefinitionId: number) {
    return this.progressiveDefinitions.find(
      (pd) => pd.Id === progressiveDefinitionId
    );
  }

  getProgressiveDefinitionMachines(machineConfigurationId: number) {
    return this.progressiveDefinitionMachines.filter(
      (pdm) => pdm.MachineConfigurationId === machineConfigurationId
    );
  }
}
